<script>
import AdvSwitch from '@advisor/components/common/AdvSwitch.vue';
import {PROP} from '@advisor/util/constants';

export default {
  name: 'AdvCheckbox',
  extends: AdvSwitch,
  props: {
    indeterminate: {...PROP.BOOLEAN_TYPE, default: false},
    indeterminateIcon: {
      ...PROP.STRING_TYPE,
      default: '$vuetify.icons.checkboxIndeterminate',
    },
    offIcon: {...PROP.STRING_TYPE, default: '$vuetify.icons.checkboxOff'},
    onIcon: {...PROP.STRING_TYPE, default: '$vuetify.icons.checkboxOn'},
  },
};
</script>

<template>
  <v-checkbox
    :id="id"
    data-test-id="onChange"
    :disabled="!isVisible(null, false)"
    :input-value="value"
    :color="color"
    :dark="dark"
    :light="light"
    :loading="loading"
    :append-icon="appendIcon"
    :append-icon-cb="appendIconCb"
    :background-color="backgroundColor"
    :error="error"
    :error-count="errorCount"
    :error-messages="errorMessages"
    :false-value="falseValue"
    :height="height"
    :hide-details="hideDetails"
    :hint="hint"
    :indeterminate="indeterminate"
    :indeterminate-icon="indeterminateIcon"
    :label="label"
    :messages="messages"
    :multiple="multiple"
    :off-icon="offIcon"
    :on-icon="onIcon"
    :persistent-hint="persistentHint"
    :prepend-icon="prependIcon"
    :prepend-icon-cb="prependIconCb"
    :readonly="readonly"
    :ripple="ripple"
    :rules="rules"
    :success="success"
    :success-messages="successMessages"
    :true-value="trueValue"
    :validate-on-blur="validateOnBlur"
    :value-comparator="valueComparator"
    @change="onChange"
  />
</template>
